import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedVerified = localStorage.getItem("isVerified") === "true";
    if (storedUser && storedUser !== "undefined") {
      try {
        const parsed = JSON.parse(storedUser);
        // Ensure _id is available (MongoDB uses _id)
        if (parsed && !parsed._id && parsed.id) {
          parsed._id = parsed.id;
        }
        console.log("Loaded user from storage:", parsed);
        console.log("User _id:", parsed?._id);
        setUser(parsed);
        setIsVerified(storedVerified);
      } catch (e) {
        console.warn("Failed to parse stored user, clearing invalid data.", e);
        localStorage.removeItem("user");
        localStorage.removeItem("isVerified");
      }
    }
  }, []);

  const login = (newUser) => {
    // Ensure _id is preserved (MongoDB uses _id, but JSON might convert it)
    if (newUser && !newUser._id && newUser.id) {
      newUser._id = newUser.id;
    }
    console.log("Logging in user:", newUser);
    console.log("User _id:", newUser?._id);
    setUser(newUser);
    setIsVerified(true);
    localStorage.setItem("user", JSON.stringify(newUser));
    localStorage.setItem("isVerified", "true");
  };

  const verify = () => {
    setIsVerified(true);
    localStorage.setItem("isVerified", "true");
  };

  const logout = () => {
    setUser(null);
    setIsVerified(false);
    localStorage.removeItem("user");
    localStorage.removeItem("isVerified");
  };

  return (
    <AuthContext.Provider value={{ user, isVerified, login, verify, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
